import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAchievements } from '@breath-lab/state';
import { Toast } from '../Toast/Toast';

export function AchievementToast() {
  const { t } = useTranslation('achievements');
  const newlyUnlocked = useAchievements((s) => s.newlyUnlocked);
  const clearNewlyUnlocked = useAchievements((s) => s.clearNewlyUnlocked);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const isVisible = newlyUnlocked.length > 0;

  useEffect(() => {
    if (!isVisible) return;

    timerRef.current = setTimeout(() => {
      clearNewlyUnlocked();
    }, 5000);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [isVisible, clearNewlyUnlocked]);

  const count = newlyUnlocked.length;
  const message = t('toast.message', { count });

  return (
    <Toast
      visible={isVisible}
      variant="achievement"
      message={message}
      onDismiss={clearNewlyUnlocked}
    />
  );
}
